import {
  AppleIcon,
  FacebookCircleIcon,
  GoogleIcon,
  LinkedinIcon,
  XIcon,
} from '@joinrepublic/dls-ui-kit';

import { E_REGION } from '@r-client/shared/feature/region';

export type SocialAuthSourceName =
  | 'google'
  | 'apple'
  | 'linkedin'
  | 'facebook'
  | 'twitter';

export interface ISocialAuthSource {
  providerName: SocialAuthSourceName;
  displayName: string;
  Icon: typeof AppleIcon;
}

const allSocialAuthSources: ISocialAuthSource[] = [
  {
    providerName: 'google',
    displayName: 'Google',
    Icon: GoogleIcon,
  },
  {
    providerName: 'apple',
    displayName: 'Apple',
    Icon: AppleIcon,
  },
  {
    providerName: 'linkedin',
    displayName: 'LinkedIn',
    Icon: LinkedinIcon,
  },
  {
    providerName: 'facebook',
    displayName: 'Facebook',
    Icon: FacebookCircleIcon,
  },
  {
    providerName: 'twitter',
    displayName: 'X',
    Icon: XIcon,
  },
];

export const getSocialAuthSources = (region: E_REGION): ISocialAuthSource[] => {
  switch (region) {
    case E_REGION.US:
      return allSocialAuthSources
        .filter((source) =>
          ['apple', 'facebook', 'twitter'].includes(source.providerName)
        )
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
    default:
      return allSocialAuthSources
        .filter((source) =>
          ['apple', 'google', 'linkedin'].includes(source.providerName)
        )
        .sort((a, b) => a.displayName.localeCompare(b.displayName));
  }
};
